var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"project__section",attrs:{"id":"Projects"}},[_c('div',{staticClass:"project__title__warpper",style:({
      backgroundImage:
        'url(' + require('@/assets/images/logo/handshake.png') + ')',
    })},[_c('p',{staticClass:"project__title center"},[_vm._v("Projects")])]),_c('div',{staticClass:"project__description__warpper",style:({
      backgroundImage:
        'url(' + require('@/assets/images/logo/logo.png') + ')',})},[_c('div',{staticClass:"project__descrption"},[_vm._v("Coming Soon To Your Community")])])])}
var staticRenderFns = []

export { render, staticRenderFns }